<template>
  <el-dialog title="商家资质" :visible.sync="dialogVisible" width="800px" :before-close="handleClose" center>
    <div>
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            企业名称
          </template>
          {{ info.business_company_name && !hidden ? info.business_company_name : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            法人
          </template>
          {{ info.business_chairman && !hidden ? info.business_chairman : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-postcard"></i>
            社会信用代码
          </template>
          {{ info.business_code && !hidden ? info.business_code : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            地址
          </template>
          {{ info.business_address && !hidden ? info.business_address : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            成立日期
          </template>
          {{ info.business_date && !hidden ? info.business_date : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-money"></i>
            注册资金
          </template>
          {{ info.business_foundation && !hidden ? info.business_foundation : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-date"></i>
            有效期
          </template>
          {{ info.business_expired && !hidden ? info.business_expired : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item :span="2">
          <template slot="label">
            <i class="el-icon-document"></i>
            经营范围
          </template>
          {{ info.business_scope && !hidden ? info.business_scope : '请点击“查看”确认信息' }}
        </el-descriptions-item>
        <el-descriptions-item :span="2" label="声明">
           <div style="color: #ed3142;">为保证平台商家信息的私密性，规避信息泄露风险，保障平台商家的合法权益，请在此页面点击“查看”按钮，查看商家资质信息。</div>
        </el-descriptions-item>
      </el-descriptions>
      <div style="text-align: center;margin-top: 20px;">
        <el-button type="primary" @click="handleClose">关 闭</el-button>
        <el-button type="primary" @click="handleShow">查 看</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'SupplyExtend',
  data() {
    return {
      dialogVisible: false,
      sid: 0,
      info: {},
      hidden: true
    }
  },
  watch: {

  },
  methods: {
    /**
     * 打开弹窗
     * @param sid 
     */
    showDialog(sid) {
      this.sid = sid
      this.getMerchantInfo()
      this.dialogVisible = true
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 显示信息
     */
    handleShow() {
      if (!this.$store.getters.getUser) {
        this.$store.dispatch("setShowLogin", true);
        return;
      }
       this.$confirm('查看此信息需要支付100元, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const currentTimestamp = new Date().getTime()
          const url = `https://apicenter.toysmodel.cn/api/658bc5aa0d846?order_no=Z${currentTimestamp}&money=100&body=增值服务：查看商家资质`
          window.open(url, '_blank')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消支付'
          });          
        });
    },
    /**
     * 获取商家信息
     */
    async getMerchantInfo() {
      const { data } = await this.$axios.post(
        this.$apiHost + "/api/mini/supply/info",
        {
          sid: this.sid,
        }
      );
      if (data.code === 1) {
        this.info = data.data.extend
      }

    },
  }
}
</script>

<style scoped></style>